// extracted by mini-css-extract-plugin
module.exports = {"ReviewRow":"Styles_ReviewRow__25TnP","Review":"Styles_Review__1ydE4","Hide":"Styles_Hide__3QhaG"};